/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Models_TitleInputs */

const en_models_title = /** @type {(inputs: Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Models`)
};

/**
* | output |
* | --- |
* | "Models" |
*
* @param {Models_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const models_title = /** @type {((inputs?: Models_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Models_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_models_title(inputs)
});